import {Avatar, Badge, Button, Dialog, Divider, Grid, MenuItem, Paper, Popover} from "@mui/material";
import React, {useEffect, useRef, useState} from "react";
import LogbookApi from "../../../../api/staffApi/logbookApi";
import logbookApi from "../../../../api/staffApi/logbookApi";
import Api from "../../../../api/index";
import {AppDispatch, useSelector} from "../../../../redux/store";

import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import {AccountCircle, PhotoCamera, Save, Undo} from "@mui/icons-material";
import {ColorBox} from 'mui-color';

import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import {DatePicker} from "@mui/x-date-pickers";
import {IRol, ISabitler} from "../../../../constants/types/logbook";
import {sabitlerKaydet} from "../../../../redux/actions/appActions";
import KisiRolPaneli from "./KisiRolPaneli";
import {showNotification} from "../../../../redux/reducers/notificationReducer";

// Yeni Componentler
import MaliOzet from "./components/MaliOzet";
import CariTablosu from "./components/CariTablosu";
import GunlukKayitlarTablosu from "./components/GunlukKayitlarTablosu";
import {KayitDuzenle, KayitEkle} from "./components/KayitModallari";

interface IKayit {
    id?: number;
    hesapId: number;
    tarih: string;
    degisim: number;
    aciklama?: string
}

const defaultKayit: IKayit = {
    id: 0,
    hesapId: 0,
    tarih: dayjs(new Date(Date.now() - 5 * (60 * 60 * 1000))).format("DD-MM-YYYY"),
    aciklama: "",
    degisim: 0
}

const KisiDetay = ({kisiId, isProfil = false}: { kisiId: number, isProfil?: boolean }) => {
    const sabitler = useSelector(state => state.app.sabitler);
    const dispatch = AppDispatch();
    const [kisi, setKisi] = useState<any>({});
    const [kisiDetay, setKisiDetay] = useState<any>(null);
    const [kisiDuzenle, setKisiDuzenle] = useState<boolean>(false);
    const [colorPicker, setColorPicker] = React.useState<null | HTMLElement>(null);
    const [hesap, setHesap] = useState<any>([]);
    const [kayit, setKayit] = useState<IKayit>({...defaultKayit});
    const [kayitEkle, setKayitEkle] = useState<boolean>(false);
    const [kayitGuncelle, setKayitGuncelle] = useState<any>(null);
    const [cariler, setCariler] = useState<any>([]);
    const [roles, setRoles] = useState<IRol[]>([]);
    const [sifreDegistir, setSifreDegistir] = useState<boolean>(false);
    const [sifreData, setSifreData] = useState({password: "", new_password: "", new_password_confirm: ""});
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(25);
    const [totalCount, setTotalCount] = useState(0);
    const fileInputRef = useRef<HTMLInputElement>(null);

    const handleAvatarUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file && kisiId >= 0) {
            const formData = new FormData();
            formData.append('avatar', file);
            LogbookApi.postKisiAvatar(kisiId, formData)
                .then(() => {
                    dispatch(showNotification({message: "Profil resmi güncellendi.", severity: "success"}));
                    refreshAll();
                })
                .catch(() => dispatch(showNotification({message: "Resim yüklenirken hata oluştu.", severity: "error"})));
        }
    };

    useEffect(() => {
        setKisiDuzenle(kisiId === -1);
        setPage(1);
        if (kisiId === -1) {
            setKisiDetay({
                username: "", password: "", isim: "", soyisim: "", rumuz: "", email: "",
                dogum_tarihi: dayjs().format("DD-MM-YYYY"), dogum_yeri: "", telefon: "",
                acil_telefon_1: "", acil_telefon_2: "", adres: "", iban: "", renk: "#000000",
                hesap_id: "", rol_id: "", rol_baslangic: dayjs().format("DD-MM-YYYY"), rol_bitis: "31-12-2099"
            });
            setKisi({});
        } else {
            setKisiDetay(null);
            setKisi({});
        }
    }, [kisiId]);

    const refreshAll = () => {
        if (kisiId >= 0) {
            LogbookApi.getKisiDetaylari(kisiId, page, pageSize)
                .then(res => bilgileriGuncelle(res))
                .catch(e => console.warn(e))
        }
    };

    const bilgileriGuncelle = (res: any) => {
        const kisiTemp = {
            hesapId: res.hesap_id, detay: res.detay, rolKayitlari: res.kisi_rol_kayitlari,
            bakiye: res.bakiye, cariBakiye: res.cari_bakiye, buAyMesailer: res.bu_ay_mesailer,
            gecenAyMesailer: res.gecen_ay_mesailer, mesailer: res.mesailer
        }

        setKisiDetay({...res?.detay})
        setKisi(kisiTemp);
        setHesap(res.gunluk_kayitlar || []);
        setTotalCount(res.total_count || 0);

        setCariler((res.cari_hesap_kayitlari || [])?.map((cari: any) => ({
            tarih: cari.tarih, miktar: cari.miktar, tip: cari.hareket_tip, sonBakiye: cari.son_bakiye
        })));
    }

    useEffect(() => {
        if (sabitler != null && kisiId >= 0) {
            LogbookApi.getKisiDetaylari(kisiId, page, pageSize).then(res => bilgileriGuncelle(res)).catch(e => console.warn(e))
        }
        if (sabitler != null) {
            Api.getPromise('/logbook/yonetim/rol/').then(res => setRoles(res)).catch(e => console.warn(e));
        }
    }, [sabitler, kisiId, page, pageSize]);

    return <>
        <Dialog open={kayitEkle} onClose={() => setKayitEkle(false)}>
            <KayitEkle hesapId={kisi?.hesapId} kayit={kayit} setKayit={setKayit} setKayitEkle={setKayitEkle}
                       bilgileriGuncelle={bilgileriGuncelle}/>
        </Dialog>
        <Dialog open={kayitGuncelle} onClose={() => setKayitGuncelle(false)}>
            <KayitDuzenle kayit={kayit} setKayit={setKayit} setKayitGuncelle={setKayitGuncelle}
                          bilgileriGuncelle={bilgileriGuncelle}/>
        </Dialog>
        <Dialog open={sifreDegistir} onClose={() => setSifreDegistir(false)}>
            <Box sx={{p: 3, display: 'flex', flexDirection: 'column', gap: 2, minWidth: '300px'}}>
                <Typography variant="h6">Şifre Değiştir</Typography>
                <TextField
                    label="Mevcut Şifre"
                    type="password"
                    fullWidth
                    value={sifreData.password}
                    onChange={(e) => setSifreData({...sifreData, password: e.target.value})}
                />
                <TextField
                    label="Yeni Şifre"
                    type="password"
                    fullWidth
                    value={sifreData.new_password}
                    onChange={(e) => setSifreData({...sifreData, new_password: e.target.value})}
                />
                <TextField
                    label="Yeni Şifre (Tekrar)"
                    type="password"
                    fullWidth
                    value={sifreData.new_password_confirm}
                    onChange={(e) => setSifreData({...sifreData, new_password_confirm: e.target.value})}
                />
                <Button
                    variant="contained"
                    onClick={() => {
                        if (sifreData.new_password !== sifreData.new_password_confirm) {
                            dispatch(showNotification({message: "Yeni şifreler uyuşmuyor.", severity: "error"}));
                            return;
                        }
                        LogbookApi.postKisiSifre(sifreData)
                            .then(() => {
                                dispatch(showNotification({
                                    message: "Şifre başarıyla değiştirildi.",
                                    severity: "success"
                                }));
                                setSifreDegistir(false);
                                setSifreData({password: "", new_password: "", new_password_confirm: ""});
                            })
                            .catch((err) => dispatch(showNotification({
                                message: err.error || "Hata oluştu.",
                                severity: "error"
                            })));
                    }}
                >
                    Kaydet
                </Button>
            </Box>
        </Dialog>
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                <Paper sx={{padding: "1rem", marginBottom: "1rem"}}>
                    <Box sx={{
                        display: "inline-flex",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>
                        <Typography variant="h6" gutterBottom component="div"
                                    padding={"1rem"}>{isProfil ? "Profil Bilgileri" : (kisiId === -1 ? "Yeni Kişi Kaydı" : "Özet")}</Typography>
                        {!isProfil && kisiId >= 0 && kisi?.detay && <Button color="secondary" onClick={() => {
                            LogbookApi.postKisiAktif(kisiId).then(() => {
                                setKisi({...kisi, detay: {...kisi?.detay, aktif: !kisi?.detay?.aktif}});
                                logbookApi.getSabitler().then((response: ISabitler) => {
                                    dispatch(sabitlerKaydet(response));
                                });
                            });
                        }}>{kisi?.detay?.aktif ? "Pasif Hale Getir" : "Aktif Hale Getir"}</Button>}
                        {isProfil && <Button color="primary" variant="outlined" onClick={() => setSifreDegistir(true)}>Şifre
                            Değiştir</Button>}
                    </Box>

                    {kisiId === 0 && !kisi?.detay ?
                        <Typography fontWeight={"bold"} padding={"1rem"}>Lütfen bir kişi seçiniz.</Typography>
                        : <Grid container spacing={1}>
                            {!isProfil && kisiId === -1 && <>
                                <Grid item xs={6}><TextField fullWidth label="Kullanıcı Adı" required
                                                             value={kisiDetay?.username ?? ""}
                                                             onChange={e => setKisiDetay({
                                                                 ...kisiDetay,
                                                                 username: e.target.value
                                                             })}/></Grid>
                                <Grid item xs={6}><TextField fullWidth label="Şifre" type="password" required
                                                             value={kisiDetay?.password ?? ""}
                                                             onChange={e => setKisiDetay({
                                                                 ...kisiDetay,
                                                                 password: e.target.value
                                                             })}/></Grid>
                            </>}
                            <Grid item xs={6}><TextField InputLabelProps={{shrink: true}} fullWidth label="Rumuz"
                                                         value={kisiDuzenle ? (kisiDetay?.rumuz ?? "") : (kisi?.detay?.rumuz ?? "")}
                                                         disabled={!kisiDuzenle} onChange={e => setKisiDetay({
                                ...kisiDetay,
                                rumuz: e.target.value
                            })}/></Grid>
                            <Grid item xs={6}>
                                <Box sx={{display: 'flex', alignItems: "center", gap: 2}}>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        ref={fileInputRef}
                                        style={{display: 'none'}}
                                        onChange={handleAvatarUpload}
                                    />
                                    <Badge
                                        overlap="circular"
                                        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                                        badgeContent={
                                            kisiDuzenle && (
                                                <IconButton
                                                    size="small"
                                                    sx={{
                                                        bgcolor: 'primary.main',
                                                        color: 'white',
                                                        width: 22,
                                                        height: 22,
                                                        '&:hover': {bgcolor: 'primary.dark'}
                                                    }}
                                                    onClick={() => fileInputRef.current?.click()}
                                                >
                                                    <PhotoCamera sx={{fontSize: 14}}/>
                                                </IconButton>
                                            )
                                        }
                                    >
                                        <Avatar
                                            src={kisiDuzenle ? (kisiDetay?.avatar) : (kisi?.detay?.avatar)}
                                            sx={{
                                                width: 45,
                                                height: 45,
                                                bgcolor: (kisiDuzenle ? kisiDetay?.renk : kisi?.detay?.renk) ?? 'primary.main',
                                                cursor: kisiDuzenle ? 'pointer' : 'default',
                                                border: '1px solid #ddd'
                                            }}
                                            onClick={() => kisiDuzenle && fileInputRef.current?.click()}
                                        >
                                            {(kisiDuzenle ? kisiDetay?.isim?.[0] : kisi?.detay?.isim?.[0]) || <AccountCircle/>}
                                        </Avatar>
                                    </Badge>

                                    <Box sx={{flexGrow: 1, display: 'flex', alignItems: 'center'}}>
                                        <IconButton
                                            disabled={!kisiDuzenle}
                                            onClick={(e) => setColorPicker(e.currentTarget)}
                                            size="small"
                                        >
                                            <Box sx={{
                                                width: 20,
                                                height: 20,
                                                borderRadius: '50%',
                                                bgcolor: (kisiDuzenle ? kisiDetay?.renk : kisi?.detay?.renk) ?? 'action.active',
                                                border: '1px solid #ccc'
                                            }}/>
                                        </IconButton>
                                        <TextField
                                            InputLabelProps={{shrink: true}}
                                            fullWidth
                                            label="Renk"
                                            variant="standard"
                                            value={(kisiDuzenle ? (kisiDetay?.renk ?? "") : (kisi?.detay?.renk ?? ""))}
                                            onChange={e => setKisiDetay({...kisiDetay, renk: e.target.value})}
                                            disabled={!kisiDuzenle}
                                            sx={{ml: 1}}
                                        />
                                    </Box>

                                    <Popover
                                        open={kisiDuzenle && Boolean(colorPicker)}
                                        anchorEl={colorPicker}
                                        onClose={() => setColorPicker(null)}
                                        anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
                                    >
                                        <ColorBox
                                            onChange={(val) => setKisiDetay({...kisiDetay, renk: "#" + val.hex})}
                                            value={kisiDetay?.renk}
                                        />
                                    </Popover>
                                </Box>
                            </Grid>
                            <Grid item xs={6}><TextField InputLabelProps={{shrink: true}} fullWidth label="İsim"
                                                         value={kisiDuzenle ? (kisiDetay?.isim ?? "") : (kisi?.detay?.isim ?? "")}
                                                         disabled={!kisiDuzenle} onChange={e => setKisiDetay({
                                ...kisiDetay,
                                isim: e.target.value
                            })}/></Grid>
                            <Grid item xs={6}><TextField InputLabelProps={{shrink: true}} fullWidth label="Soyisim"
                                                         value={kisiDuzenle ? (kisiDetay?.soyisim ?? "") : (kisi?.detay?.soyisim ?? "")}
                                                         disabled={!kisiDuzenle} onChange={e => setKisiDetay({
                                ...kisiDetay,
                                soyisim: e.target.value
                            })}/></Grid>
                            <Grid item xs={6}><DatePicker label="Doğum Tarihi" sx={{width: "100%"}}
                                                          value={dayjs(kisiDuzenle ? (kisiDetay?.dogum_tarihi ?? "") : (kisi?.detay?.dogum_tarihi ?? ""), "DD-MM-YYYY")}
                                                          disableFuture disabled={!kisiDuzenle}
                                                          onChange={newValue => setKisiDetay({
                                                              ...kisiDetay,
                                                              dogum_tarihi: newValue?.format("DD-MM-YYYY")
                                                          })}/></Grid>
                            <Grid item xs={6}><TextField InputLabelProps={{shrink: true}} fullWidth label="Doğum Yeri"
                                                         value={kisiDuzenle ? (kisiDetay?.dogum_yeri ?? "") : (kisi?.detay?.dogum_yeri ?? "")}
                                                         disabled={!kisiDuzenle} onChange={e => setKisiDetay({
                                ...kisiDetay,
                                dogum_yeri: e.target.value
                            })}/></Grid>
                            <Grid item xs={6}><TextField InputLabelProps={{shrink: true}} fullWidth label="Telefon"
                                                         value={kisiDuzenle ? (kisiDetay?.telefon ?? "") : (kisi?.detay?.telefon ?? "")}
                                                         disabled={!kisiDuzenle} onChange={e => setKisiDetay({
                                ...kisiDetay,
                                telefon: e.target.value
                            })}/></Grid>
                            <Grid item xs={6}><TextField InputLabelProps={{shrink: true}} fullWidth label="Email"
                                                         value={kisiDuzenle ? (kisiDetay?.email ?? "") : (kisi?.detay?.email ?? "")}
                                                         disabled={!kisiDuzenle} onChange={e => setKisiDetay({
                                ...kisiDetay,
                                email: e.target.value
                            })}/></Grid>
                            <Grid item xs={12}><TextField InputLabelProps={{shrink: true}} fullWidth multiline
                                                          minRows={2} label="Adres"
                                                          value={kisiDuzenle ? (kisiDetay?.adres ?? "") : (kisi?.detay?.adres ?? "")}
                                                          disabled={!kisiDuzenle} onChange={e => setKisiDetay({
                                ...kisiDetay,
                                adres: e.target.value
                            })}/></Grid>
                            <Grid item xs={9}><TextField InputLabelProps={{shrink: true}} fullWidth label="IBAN"
                                                         value={kisiDuzenle ? (kisiDetay?.iban ?? "") : (kisi?.detay?.iban ?? "")}
                                                         disabled={!kisiDuzenle} onChange={e => setKisiDetay({
                                ...kisiDetay,
                                iban: e.target.value
                            })}/></Grid>
                            {!isProfil && (
                                <>
                                    <Grid item xs={12}><Divider sx={{my: 1}}>Sistem Ayarları</Divider></Grid>
                                    <Grid item xs={6}><TextField select fullWidth label="Mali Hesap Bağla"
                                                                 disabled={!kisiDuzenle}
                                                                 value={kisiDuzenle ? (kisiDetay?.hesap_id ?? "") : (kisi?.hesapId ?? "")}
                                                                 onChange={e => setKisiDetay({
                                                                     ...kisiDetay,
                                                                     hesap_id: e.target.value
                                                                 })}>
                                        <MenuItem value="">Seçiniz</MenuItem>{sabitler?.hesaplar?.map((h: any) => (
                                        <MenuItem key={h.id} value={h.id}>{h.hesapAdi} ({h.hesapTipi})</MenuItem>))}
                                    </TextField>
                                    </Grid>
                                </>
                            )}
                            {!isProfil && kisiId === -1 && <>
                                <Grid item xs={6}><TextField select fullWidth label="Başlangıç Rolü"
                                                             value={kisiDetay?.rol_id ?? ""}
                                                             onChange={e => setKisiDetay({
                                                                 ...kisiDetay,
                                                                 rol_id: e.target.value
                                                             })}>
                                    <MenuItem value="">Seçiniz</MenuItem>{roles.map((r: any) => (
                                    <MenuItem key={r.id} value={r.id}>{r.rolAdi}</MenuItem>))}</TextField>
                                </Grid>
                                <Grid item xs={6}><DatePicker label="Rol Başlangıç" sx={{width: "100%"}}
                                                              value={dayjs(kisiDetay?.rol_baslangic, "DD-MM-YYYY")}
                                                              onChange={v => setKisiDetay({
                                                                  ...kisiDetay,
                                                                  rol_baslangic: v?.format("DD-MM-YYYY")
                                                              })}/></Grid>
                                <Grid item xs={6}><DatePicker label="Rol Bitiş" sx={{width: "100%"}}
                                                              value={dayjs(kisiDetay?.rol_bitis, "DD-MM-YYYY")}
                                                              onChange={v => setKisiDetay({
                                                                  ...kisiDetay,
                                                                  rol_bitis: v?.format("DD-MM-YYYY")
                                                              })}/></Grid>
                            </>}
                            {!isProfil && <Grid item xs={kisiId === -1 ? 12 : 3}>
                                {kisiDuzenle ?
                                    <Box sx={{width: '100%', display: 'flex', justifyContent: 'flex-end', gap: 2}}>
                                        <Button variant="contained" color="primary" startIcon={<Save/>}
                                                sx={{minWidth: '10rem'}} onClick={() => {
                                            const promise = kisiId === -1 ? LogbookApi.postKisiDetaylari(kisiDetay) : LogbookApi.putKisiDetaylari(kisiDetay);
                                            promise.then(() => {
                                                if (kisiId === -1) {
                                                    logbookApi.getSabitler().then(res => dispatch(sabitlerKaydet(res)));
                                                    dispatch(showNotification({
                                                        message: "Yeni kişi başarıyla kaydedildi.",
                                                        severity: "success"
                                                    }));
                                                } else {
                                                    refreshAll();
                                                    dispatch(showNotification({
                                                        message: "Değişiklikler kaydedildi.",
                                                        severity: "success"
                                                    }));
                                                }
                                                setKisiDuzenle(false);
                                            }).catch(err => {
                                                // Hata Api layer tarafından basılıyor
                                            });
                                        }}>{kisiId === -1 ? "Yeni Kişi Kaydet" : "Kaydet"}</Button>
                                        <IconButton onClick={() => {
                                            if (kisiId !== -1) setKisiDetay({...kisi.detay});
                                            setKisiDuzenle(false);
                                        }} color="secondary"><Undo/></IconButton>
                                    </Box> : <Button variant="contained" color="secondary" size="small" fullWidth
                                                     sx={{height: "100%"}}
                                                     onClick={() => setKisiDuzenle(true)}>Düzenle</Button>}
                            </Grid>}
                        </Grid>}
                    <MaliOzet kisi={kisi}/>
                </Paper>
                {kisiId >= 0 && <CariTablosu cariler={cariler}/>}
                {kisiId >= 0 && <KisiRolPaneli kisiId={kisiId} onUpdate={refreshAll} isProfil={isProfil}/>}
            </Grid>
            <Grid item xs={12} md={6}>
                {kisiId >= 0 && <GunlukKayitlarTablosu hesap={hesap} kisiId={kisiId} kisiHesapId={kisi?.hesapId}
                                                       bilgileriGuncelle={bilgileriGuncelle} setKayit={setKayit}
                                                       setKayitEkle={setKayitEkle} setKayitGuncelle={setKayitGuncelle}
                                                       isProfil={isProfil}
                                                       page={page} pageSize={pageSize} totalCount={totalCount}
                                                       onPageChange={setPage} onPageSizeChange={setPageSize}/>}
            </Grid>
        </Grid>
    </>
}

export default KisiDetay;
